import React from 'react'
import { withRouter } from 'react-router-dom'

import {
  Input,
  Button,
  SelectWithData,
  KeyValueTable as InformationInputTable,
  DynamicPicklist
} from '../'

import {
  decodeBase64,
  getDateOfBirthFromSouthAfricanID
} from '../../utils'

import {
  QUERY_DIVISIONS_BY_EMPLOYER
} from '../../queries'

import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

class IdentityInformationInput extends React.Component {
  state = {
    identityExistsAlready: false,
    // identity info
    firstName: '',
    lastName: '',
    otherName: '',
    language: '',
    dateOfBirth: '',
    deceased: '',
    membershipStatus: '',
    identityType: '',
    identityValue: '',
    // contact info
    division: this.props.division,
    position: '',
    role: '',
    // validation
    displayInputError: [ false ]
  }

  goBack = () => {
    this.props.history.goBack()
  }

  requiredFieldsValid = () => (
    (
      (
        this.state.identityType === 'za_id' &&
        this.state.identityValue.length === 13 &&
        !isNaN(this.state.identityValue)
      ) ||
      this.state.identityType === 'passport'
    ) &&
      this.state.firstName && this.state.lastName && this.state.language &&
      this.state.dateOfBirth && this.state.membershipStatus
  )

  canSave = () => {
    if (this.requiredFieldsValid()) {
      return true
    } else {
      let errorFields = []
      errorFields.push(true)

      if (!this.state.identityType) {
        errorFields.push('identityType')
      }
      if (!this.state.identityValue) {
        errorFields.push('identityValue')
      }
      if (this.state.identityType === 'za_id' &&
          (this.state.identityValue.length !== 13 ||
          isNaN(this.state.identityValue))) {
        // something's wrong with id type/value combination input
        errorFields.push('identityValue')
        errorFields.push('identityType')
      }
      if (!this.state.firstName) {
        errorFields.push('firstName')
      }
      if (!this.state.lastName) {
        errorFields.push('lastName')
      }
      if (!this.state.language) {
        errorFields.push('language')
      }
      if (!this.state.dateOfBirth) {
        errorFields.push('dateOfBirth')
      }

      if (!this.state.membershipStatus) {
        errorFields.push('membershipStatus')
      }

      this.setState({
        displayInputError: errorFields
      })

      return false
    }
  }

  saveIdentityInformation = () => {
    if (this.canSave()) {
      let identityInfo = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        otherName: this.state.otherName,
        language: this.state.language,
        dateOfBirth: this.state.dateOfBirth,
        deceased: false,
        membershipStatus: this.state.membershipStatus,
        identityType: this.state.identityType,
        identityValue: this.state.identityValue
      }

      let contactInfo = {
        position: this.state.position,
        role: this.state.role
      }
      if (this.state.division) {
        contactInfo.division = this.state.division
      }

      if (this.props.employerId) {
        contactInfo.employer = this.props.employerId
      }

      this.props.addIdentity({variables: {input: identityInfo}})
        .then(this.setState({ displayInputError: [ false ] }))
        .then(({ data }) => {
          contactInfo.identity = data.identityMutate.identity.id
          this.props.addContact({ variables: { input: contactInfo }})
            .then(this.props.onSaved)  // TODO: show save successful message
            .catch((error) => {
              console.log('there was an error saving the contact', error);
            })
        })
        .catch((error) => {
          console.log('there was an error saving the identity', error);
        })
    }
  }

  autoFillAfterIdentityNumberInput = (e) => {
    let idNumber = e.target.value

    if (this.state.identityType === 'za_id') {
      let dob = getDateOfBirthFromSouthAfricanID(idNumber)

      this.setState({
        identityValue: idNumber,
        dateOfBirth: dob.format('YYYY-MM-DD')
      })
    }

    if (this.state.identityType === 'za_id' && idNumber.length === 13) {
      // check for existing identity
      this.props.data.refetch({ idNumber: idNumber })
      // form fields will auto-fill via componentWillReceiveProps if identity exists
    }
  }

  handleIdentityTypeInputChange = (e) => {
    let idType = e.target.value

    if (idType === 'za_id'
      && this.state.identityValue !== ''
      && this.state.dateOfBirth === null) {

      let dob = getDateOfBirthFromSouthAfricanID(this.state.identityValue)

      this.setState({
        identityType: idType,
        dateOfBirth: dob
      })
    } else {
      this.setState({
        identityType: idType
      })
    }

    if (idType === 'za_id' && this.state.identityValue.length === 13) {
      // check for existing identity
      this.props.data.refetch({ idNumber: this.state.identityValue })
      // form fields will auto-fill via componentWillReceiveProps if identity exists
    }
  }

  // The following functions handles state change for all inputs using the Input component.
  // Since these Input components have 'id' props matching their corresponding state variables,
  // this single function serve them all
  handleInputChange = (e) => this.setState({ [e.target.id]: e.target.value })

  handleDivisionChange = (division) => this.setState({ division })

  render() {
    let inputFields = {
      'Identity type': <SelectWithData
                        id='identityType'
                        forField='IdentityIdentityType'
                        value={this.state.identityType}
                        onChange={this.handleIdentityTypeInputChange}
                        hasError={this.state.identityValue && !this.state.identityType}
                      />,
      'Identity number':  <Input
                            id='identityValue'
                            placeholder='Identity number'
                            value={this.state.identityValue || ''}
                            onChange={this.handleInputChange}
                            onBlur={this.autoFillAfterIdentityNumberInput}
                            hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('identityValue')}
                          />,
      'First name': <Input
                      id='firstName'
                      placeholder='First name'
                      value={this.state.firstName || ''}
                      onChange={this.handleInputChange}
                      hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('firstName')}
                    />,
      'Last name':  <Input
                      id='lastName'
                      placeholder='Last name'
                      value={this.state.lastName || ''}
                      onChange={this.handleInputChange}
                      hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('lastName')}
                    />,
      'Other name': <Input
                      id='otherName'
                      placeholder='Other name'
                      value={this.state.otherName || ''}
                      onChange={this.handleInputChange}
                    />,
      'Language': <SelectWithData
                    id='language'
                    forField='IdentityLanguage'
                    value={this.state.language}
                    onChange={this.handleInputChange}
                    hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('language')}
                  />,
      'Date of birth':  <Input
                          id='dateOfBirth'
                          type='date'
                          placeholder='Date of birth'
                          value={this.state.dateOfBirth}
                          onChange={this.handleInputChange}
                          hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('dateOfBirth')}
                        />,
      'Status': <SelectWithData
                  id='membershipStatus'
                  forField='IdentityMembershipStatus'
                  value={this.state.membershipStatus}
                  onChange={this.handleInputChange}
                  hasError={this.state.displayInputError[0] && this.state.displayInputError.includes('status')}
                />,
      'Division': <DynamicPicklist
                    id='division'
                    query={QUERY_DIVISIONS_BY_EMPLOYER}
                    field='name'
                    defaultValue='Any'
                    params={{ employer: decodeBase64(this.props.employerId) }}
                    value={this.state.division || ''}
                    onChange={this.handleDivisionChange}
                    inline={false}
                  />,
      'Position': <Input
                    id='position'
                    placeholder='Position'
                    value={this.state.position}
                    onChange={this.handleInputChange}
                  />,
      'Role': <Input
                id='role'
                placeholder='Role'
                value={this.state.role}
                onChange={this.handleInputChange}
              />
    }

    return (
      <div>
        <InformationInputTable data={inputFields} />
        <div className='slds-m-top_medium slds-float_right'>
          <Button
            onClick={this.props.onCancelClick}
            minWidth={120}
            className='slds-m-right_x-small'>
            Cancel
          </Button>
          <Button
            type='brand'
            onClick={this.saveIdentityInformation}
            minWidth={120}
            disabled={!this.requiredFieldsValid() || this.state.saveInProgess}>
            {this.state.saveInProgess
              ? 'Saving...'
              : 'Save'
            }
          </Button>
        </div>
      </div>
    )
  }
}

export const getIdentityInformation = gql`
  query($idNumber: String, $preventQuery: Boolean!) {
    identities(identityValue: $idNumber) @skip(if: $preventQuery) {
      edges {
        node {
          ...Identity
        }
      }
    }
  }
  ${fragments.identity}
`

export const addIdentity = gql`
  mutation addIdentity($input: IdentityMutationInput!) {
    identityMutate(input: $input) {
      identity {
        ...Identity
        defaultAddressType
        addresses {
          edges {
            node {
              ...Address
            }
          }
        }
      }
    }
  }
  ${fragments.identity}
  ${fragments.address}
`

export const addContact = gql`
  mutation addContact($input: ContactMutationInput!) {
    contactMutate(input: $input) {
      contact {
        ...Contact
      }
    }
  }
  ${fragments.contact}
`

export const withData =
  graphql(getIdentityInformation, {
    options: ({ idNumber }) => ({
      variables: {
        idNumber,
        preventQuery: !idNumber
      }
    })
  })

export const withIdentityAddition =
  graphql(addIdentity, {
    name: 'addIdentity'
  })

export const withContactAddition =
  graphql(addContact, {
    name: 'addContact'
  })

export default compose(
  withData,
  withIdentityAddition,
  withContactAddition,
  withRouter
)(IdentityInformationInput)



// WEBPACK FOOTER //
// ./src/components/identity-information-input/index.js